const productCardTooltip = () => {
  const endingAttrs = document.querySelectorAll('.available-by');
  if (!endingAttrs.length) return;

  endingAttrs.forEach(attr => {
    attr.addEventListener('click', (e) => {
      e.preventDefault();

      document.querySelectorAll('.tooltip-box').forEach(t => t.remove());

      const tooltip = document.createElement('div');
      tooltip.className = 'tooltip-box';
      tooltip.innerHTML = `
        <div>${attr.dataset.tooltip}</div>
        <span class="close-tooltip" aria-label="Close">&times;</span>
      `;
      attr.classList.add('tooltip-wrapper');
      attr.appendChild(tooltip);

      setTimeout(() => {
        tooltip.classList.add('active');

        // Detect overflow and shift if needed
        const rect = tooltip.getBoundingClientRect();
        const overflowRight = rect.right - window.innerWidth;

        if (overflowRight > 0) {
          tooltip.style.transform = `translateX(-${overflowRight + 16}px)`;
        }
      }, 10);

      tooltip.querySelector('.close-tooltip').addEventListener('click', () => {
        tooltip.remove();
      });

      const clickOutsideHandler = (ev) => {
        if (!tooltip.contains(ev.target) && ev.target !== attr) {
          tooltip.remove();
          document.removeEventListener('click', clickOutsideHandler);
        }
      };
      document.addEventListener('click', clickOutsideHandler);
    });
  });
};

export default productCardTooltip;
